import axios from "axios";
import TokenService from "./token.service";
import { logout, getCurrentUser } from '../common/utils';

function refreshToken(){
    return instance.post("/token/refresh/", {
        refresh: TokenService.getLocalRefreshToken(),
    });
}

const API_BASE_URL = import.meta.env.VITE_API_URL || "https://api-hlg.aditushealth.com.br/api/v1/";

const instance = axios.create({
    baseURL: API_BASE_URL
});

instance.interceptors.request.use(
    (config) => {
        const token = TokenService.getLocalAccessToken();
        if (token) {
            config.headers["Authorization"] = 'Bearer ' + token;
        }

        try {
            const currentUser = getCurrentUser();
            if (currentUser && currentUser.acesso_liberado === true && currentUser.ambiente_programa_id) {
                config.headers["X-Programa-ID"] = currentUser.ambiente_programa_id;
            }
        } catch (e) {
            console.error("Erro ao tentar adicionar header X-Programa-ID:", e);
        }

        if (config.data instanceof FormData) {
            delete config.headers["Content-Type"];
        } else {
            config.headers["Content-Type"] = "application/json";
        }

        if (config.method === 'get') {
            const dados_usuario = getCurrentUser();

            if (dados_usuario?.tipo_usuario) {
                // Garante que params exista
                config.params = config.params || {};
                // Só adiciona se ainda não foi passado explicitamente
                if (!config.params.tipo_usuario) {
                    config.params.tipo_usuario = dados_usuario.tipo_usuario;
                }
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (res) => {
        try {
            const url = res?.config?.url || '';
            if (url.indexOf('/visitas/dashboards/') !== -1 || url.indexOf('/programas/') === 0 || url.startsWith('programas/')) {
                const debug = {
                    ts: new Date().toISOString(),
                    url,
                    status: res?.status,
                    dataType: Array.isArray(res?.data) ? 'array' : typeof res?.data,
                    keys: res?.data && typeof res.data === 'object' && !Array.isArray(res.data) ? Object.keys(res.data) : null,
                    data: res?.data,
                };
                console.log('[api][dashboard]', debug);
                window.__lastDashboardApi = window.__lastDashboardApi || [];
                window.__lastDashboardApi.push(debug);
                if (window.__lastDashboardApi.length > 30) window.__lastDashboardApi.shift();
                try { sessionStorage.setItem('lastDashboardApi', JSON.stringify(window.__lastDashboardApi)); } catch (_) { /* ignore */ }
            }
        } catch (_) { /* ignore */ }
        return res;
    },
    async (err) => {
        const originalConfig = err.config;

        if (originalConfig.url !== "/login" && originalConfig.url !== "/token/refresh/" && err.response && err.response.data) {
            if (err.response.data.code === "token_not_valid") {
                try {
                    const rs = await refreshToken();
                    TokenService.updateLocalAccessToken(rs.data.access);        
                    instance.defaults.headers.common["Authorization"] = 'Bearer '+ rs.data.access;
                    return instance(originalConfig);
                }
                catch (_error) {
                    logout();
                    window.location.href = '/';

                    if (_error.response && _error.response.data) {
                        return Promise.reject(_error.response.data);
                    }
          
                    return Promise.reject(_error);
                }
            }
        }

        return Promise.reject(err);
    }
);

export default instance;
